import { Suspense, useState } from 'react'
import { useMatch, useSearchParams } from 'react-router'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { LayoutPage } from '@/components/layout/page'
import { Card } from '@/components/ui/card'
import { NoAccessError } from '@/lib/errors'
import { useCompanyPath, useIdCompany, useRBAC } from '@/lib/hooks'
import { CancelInvitationDialog } from '@/routes/user-management/cancel-invitation-dialog'
import { InviteUsersSheet } from '@/routes/user-management/invite-users-sheet'
import { RemoveUserFromCompanyDialog } from '@/routes/user-management/remove-user-from-company-dialog'
import { TransferOwnershipSheet } from '@/routes/user-management/transfer-ownership-sheet'
import { UpdateUserAccessSheet } from '@/routes/user-management/update-user-access-sheet'
import { UsersTable } from '@/routes/user-management/users-table'
import { UsersTableSkeleton } from '@/routes/user-management/users-table/fallback'
import { UsersTableHeader } from '@/routes/user-management/users-table/header'

export const UserManagementPage = () => {
  const { navigateToPath } = useCompanyPath()
  const { idCompany } = useIdCompany()
  const { rbac } = useRBAC()
  const [searchParams] = useSearchParams()
  const search = searchParams.get('search') ?? ''
  const [filterTerm, setFilterTerm] = useState(search)

  const hasRbacAccess = rbac.company(idCompany).users.view.can()

  if (!hasRbacAccess) {
    throw new NoAccessError()
  }

  return (
    <LayoutPage browserTitle="Users" fallback={<CardSkeleton />}>
      <Card>
        <UsersTableHeader
          filterTerm={filterTerm}
          setFilterTerm={setFilterTerm}
        />
        <Suspense fallback={<UsersTableSkeleton />}>
          <UsersTable filterTerm={filterTerm} />
        </Suspense>
        <InviteUsersSheet
          isOpen={Boolean(useMatch('/user-management/invite-users'))}
          onClose={() =>
            navigateToPath({
              pathname: '/user-management',
              options: { replace: true },
            })
          }
        />
        <CancelInvitationDialog
          isOpen={Boolean(
            useMatch('/user-management/cancel-invitation/:idInvitation')
          )}
          onClose={() =>
            navigateToPath({
              pathname: '/user-management',
              options: { replace: true },
            })
          }
        />
        <RemoveUserFromCompanyDialog
          isOpen={Boolean(useMatch('/user-management/remove-user/:idUser'))}
          onClose={() =>
            navigateToPath({
              pathname: '/user-management',
              options: { replace: true },
            })
          }
        />
        <UpdateUserAccessSheet
          isOpen={Boolean(
            useMatch('/user-management/update-user-access/:idUser')
          )}
          onClose={() =>
            navigateToPath({
              pathname: '/user-management',
              options: { replace: true },
            })
          }
        />
        <TransferOwnershipSheet
          isOpen={Boolean(useMatch('/user-management/transfer-ownership'))}
          onClose={() =>
            navigateToPath({
              pathname: '/user-management',
              options: { replace: true },
            })
          }
        />
      </Card>
    </LayoutPage>
  )
}
